import { render } from "./SessionExpiredOverlay.vue?vue&type=template&id=88701474&scoped=true"
import script from "./SessionExpiredOverlay.vue?vue&type=script&lang=js"
export * from "./SessionExpiredOverlay.vue?vue&type=script&lang=js"

import "./SessionExpiredOverlay.vue?vue&type=style&index=0&id=88701474&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88701474"]])

export default __exports__